var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNonimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M24.69 24.5l-6.9-6.9-3.044-3.044-9.179-9.175-1.6-1.6L2.285 2.1.69 3.7 3.3 6.321v14.9a2.27 2.27 0 0 0 2.263 2.263h14.9l2.62 2.616zM5.567 21.223V8.584l7.74 7.74-.95 1.188-2.263-3.078L6.7 18.96h9.245l2.263 2.263zm3.2-15.842L6.506 3.118h14.9a2.27 2.27 0 0 1 2.263 2.263v14.9l-2.263-2.263V5.381z",
    transform: "translate(-0.69 -2.1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNonimg);
export default __webpack_public_path__ + "static/media/icon-nonimg.d10c41ff.svg";
export { ForwardRef as ReactComponent };